enum Style {
	red = "red",
	blue = "blue",
	black = "black",
	green = "green",
	purple = "purple",
	teal = "teal",
	bluePink = "blue-pink",
	redGreen = "red-green",
	pinkBlue = "pink-blue",
	orangeRed = "orange-red",
	redOrange = "red-orange",
	blueGreen = "blue-green",
	bluePurple = "blue-purple",
	purpleBlue = "purple-blue",
	darkOrange = "dark-orange",
	pinkPurple = "pink-purple",
	orangeGreen = "orange-green",
	greenOrange = "green-orange",
	brightOrange = "bright-orange",
	purpleOrange = "purple-orange",
}

export default Style;
